<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useCallDevices } from 'dashboard/composables/useCallDevices';
import { useWacallsCall } from 'dashboard/composables/useWacallsCall';
import { useAlert } from 'dashboard/composables';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  conversation: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
const store = useStore();

// Gate: show only when the account has a call device paired to this inbox.
// Uses a direct API lookup instead of the inbox serializer field, which may
// not be present in all code paths that render this component.
const { hasDeviceForInbox } = useCallDevices();

const shouldRender = computed(() =>
  hasDeviceForInbox(props.conversation?.inbox_id)
);

const { startCall } = useWacallsCall();

const onClick = async () => {
  const conversationId = props.conversation?.id;
  const contactName = props.conversation?.meta?.sender?.name || '';
  const phone = props.conversation?.meta?.sender?.phone_number || '';

  store.dispatch('wacallsCall/setActiveCall', {
    conversationId,
    contactName,
    phone,
    status: 'calling',
  });

  try {
    const { callId } = await startCall(conversationId);
    // Store the callId so the answered/terminated webhooks can match it.
    // Status stays 'calling' until wacalls_call.answered arrives.
    store.dispatch('wacallsCall/setActiveCall', { callId });
  } catch (e) {
    store.dispatch('wacallsCall/reset');
    useAlert(
      e?.code === 'mic_denied'
        ? t('CONVERSATION.WACALLS_CALL.ERROR_MIC')
        : t('CONVERSATION.WACALLS_CALL.ERROR_GENERIC')
    );
  }
};
</script>

<template>
  <span class="contents">
    <Button
      v-if="shouldRender"
      v-tooltip.top-end="t('CONVERSATION.WACALLS_CALL.CALL')"
      icon="i-ph-phone"
      sm
      faded
      slate
      @click="onClick"
    />
  </span>
</template>
